import { Monitor } from "lucide-react";
import { cn } from "@/lib/utils";
import { ViewSection } from "@/views/shared";
import { HomeRow, HomeRowList } from "./HomeRow";

export interface MachinePresenceEntry {
  key: string;
  label: string;
  online: boolean;
  activeSessionCount: number;
}

export function MachinePresence({
  machines,
  onOpen,
}: {
  machines: MachinePresenceEntry[];
  onOpen: () => void;
}) {
  if (machines.length === 0) return null;
  return (
    <ViewSection title="Machines">
      <HomeRowList>
        {machines.map((m) => (
          <HomeRow key={m.key} onClick={onOpen} className="py-2.5">
            <Monitor className="h-4 w-4 shrink-0 text-muted-foreground" />
            <div className="flex min-w-0 flex-1 items-center gap-2">
              <span
                className={cn(
                  "h-1.5 w-1.5 shrink-0 rounded-full",
                  m.online
                    ? "bg-primary shadow-[0_0_6px_hsl(var(--primary))]"
                    : "bg-muted-foreground/40",
                )}
              />
              <span className="truncate text-sm text-foreground">{m.label}</span>
              <span className="ml-auto shrink-0 text-[10px] text-muted-foreground">
                {m.online
                  ? `${m.activeSessionCount} active`
                  : "offline"}
              </span>
            </div>
          </HomeRow>
        ))}
      </HomeRowList>
    </ViewSection>
  );
}
